import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on, Action } from '@ngrx/store';

import * as LeaderBoardActions from './leader-board.actions';
import { Leader } from '@fantaz/shared/data-access/models';

export const LEADER_BOARD_FEATURE_KEY = 'leaderBoard';

export interface LeaderState extends EntityState<Leader> {
  selectedId?: string | number; // which LeaderBoard record has been selected
  loaded: boolean; // has the LeaderBoard list been loaded
  loading: boolean; // has the LeaderBoard list is loading
  total: number; // total players
  error?: string | null; // last known error (if any)
}

export interface LeaderBoardPartialState {
  readonly [LEADER_BOARD_FEATURE_KEY]: LeaderState;
}

export const leaderBoardAdapter: EntityAdapter<Leader> =
  createEntityAdapter<Leader>({
    selectId: (leader: Leader) => leader.id,
  });

export const leaderInitialState: LeaderState =
  leaderBoardAdapter.getInitialState({
    // set initial required properties
    loaded: false,
    loading: false,
    total: 0,
  });

const reducer = createReducer(
  leaderInitialState,
  on(LeaderBoardActions.loadLeaderBoard, (state) => ({
    ...state,
    loaded: false,
    loading: true,
    error: null,
  })),
  on(
    LeaderBoardActions.loadLeaderBoardSuccess,
    (state, { leaderBoard, total }) =>
      leaderBoardAdapter.setAll(leaderBoard, {
        ...state,
        loaded: true,
        loading: false,
        total,
      }),
  ),
  on(LeaderBoardActions.loadLeaderBoardFailure, (state, { error }) => ({
    ...state,
    error,
  })),
);

export function leaderBoardReducer(
  state: LeaderState | undefined,
  action: Action,
) {
  return reducer(state, action);
}
